const TourGuidePage = () => {
    return <div>TourGuidePage</div>;
};

export default TourGuidePage;
